import { render, staticRenderFns } from "./DeleteReport.vue?vue&type=template&id=a07ba2a8"
import script from "./DeleteReport.vue?vue&type=script&lang=js"
export * from "./DeleteReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports